export default __webpack_public_path__ + "static/media/img2.2e85a920.webp";